var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 67,
    viewBox: "0 0 63 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7549 66.1097V65.2089H62.1387V56.4346H62.9994V66.1097H53.7549Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000130653 56.4365L0.860974 56.4365L0.860974 65.2064L9.24902 65.2064L9.24902 66.1067L-0.000131057 66.1067L-0.000130653 56.4365Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7655 31.5868H14.9752V26.1807H12.3929V28.8836H9.81055V31.5863H12.3929H9.81055V39.6953H12.3929H15.1019V36.9925H12.3929V34.2895H29.707V52.5432H32.2893V31.5868H30.7655Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80918 26.1807H4.64453V28.8831H9.80918V26.1807Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7086 28.8838H24.5439V31.5865H29.7086V28.8838Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5434 26.1807H19.3789V28.8831H24.5434V26.1807Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1262 11.2217H24.5439V16.0509H27.1262V11.2217Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0061 8.45898H29.4238V13.9234H32.0061V8.45898Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8724 28.8838H32.29V31.5865H34.8724V28.8838Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9956 31.3203H37.4131V38.4533H39.9956V31.3203Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2903 26.1807H29.708V28.8831H32.2903V26.1807Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4547 26.1812V23.4785H32.29V26.1812H37.4547Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4066 39.6962H37.4111V38.4544H34.8291V45.6763H37.4111V42.3986H39.8524V45.1007H42.4348V42.4412H44.989V36.7256H42.4066V39.6962Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1545 55.2461H47.5723V57.9486H50.1545V55.2461Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0299 50.2295H24.4473V61.0399H27.0299V55.2465H29.7069V52.5437H27.0299V50.2295Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6658 42.2871H4.72266V60.6523H22.2692V57.949H22.2482V44.9902H22.2692V42.2871H19.6658ZM19.6658 57.9486H7.30479V44.9902H19.6658V57.9486Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3188 57.9482H50.1543V60.651H55.3188V57.9482Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.333 57.9779V60.6807H42.9154V55.2754H40.333V57.9779Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9207 57.9482H29.708V60.651H37.9207V57.9482Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5716 34.0244H44.9893V36.727H47.5716V34.0244Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1545 31.3203H47.5723V34.023H50.1545V31.3203Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.875 25.916H49.6045V28.6187H54.875V25.916Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3512 37.0361V31.6309H54.7688V34.3334H52.1865V37.0361H57.3512Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1869 37.0361H49.6045V39.7386H52.1869V37.0361Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7688 39.7383H52.1865V42.441H54.7688V39.7383Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7688 50.5499V55.2462H57.3512V47.3013H54.7688V45.1445H52.1865V50.5499H54.7688Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9886 49.8402H37.9189V52.5433H44.9886V55.2456H47.571V45.144H52.1852V42.4414H44.9886V49.8402Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9204 52.5439H32.29V55.2465H37.9204V52.5439Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.752 36.873V39.6948H24.4483V45.1001H27.0307V39.6943H24.4483V36.873H21.752Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3576 47.4258H9.63184V55.5117H17.3576V47.4258Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6658 23.4771H22.2692V20.7745H22.2482V7.81622H22.2692V5.11328H4.72266V23.4771H19.6658ZM7.30479 7.81622H19.6658V20.775H7.30479V7.81622Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3576 10.252H9.63184V18.3378H17.3576V10.252Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6379 7.81622V5.11328H40.0911V11.2215H34.4633V13.9242H32.0083V18.1776H29.7086V16.0509H27.1263V18.1776H24.5439V26.1814H27.1263V20.8805H34.5906V13.9242H40.0911V23.4771H44.991V28.618H40.0167V31.3207H47.5733V23.4771H57.6378V20.7745H57.6165V7.81622H57.6379ZM55.0343 20.775H42.6738V7.81622H55.0347L55.0343 20.775Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7257 10.252H45V18.3378H52.7257V10.252Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9994 9.67497H62.1387V0.900633H53.7549V0H62.9994V9.67497Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26486 0V0.900504H0.881056V9.67484H0.0205078V0H9.26486Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.77b6fbba8eb963aef34df3584203cb9d.svg";
export { ForwardRef as ReactComponent };